// docs/142: the thirteen dye choices as swatches (Natural, then the twelve), each its ramp's four shades.
// Used by the forge, the `?itemqa=1` dresser and the dyer's counter.
import { DYE_CHOICES, dyeName, dyeRamp } from '../../core/heroes/dyes';

export interface DyeSwatchesProps {
  value: number;
  onChange(dye: number): void;
  label?: string;
  /** A dye to mark as the hero's own (the dyer's counter). */
  current?: number;
  disabled?: boolean;
  className?: string;
  'data-testid'?: string;
}

export function DyeSwatches({ value, onChange, label = 'Dye', current, disabled, className = '', ...rest }: DyeSwatchesProps) {
  return (
    <div role="radiogroup" aria-label={label} className={`fk-dyes ${className}`} data-testid={rest['data-testid'] ?? 'dye-swatches'} data-dye={value}>
      {DYE_CHOICES.map((d) => {
        const r = dyeRamp(d);
        const on = d === value;
        return (
          <button key={d} type="button" role="radio" aria-checked={on} disabled={disabled} title={`${dyeName(d)}${d === current ? ' (now)' : ''}`}
            aria-label={dyeName(d)} className={`fk-dyes__swatch${on ? ' is-on' : ''}${d === current ? ' is-now' : ''}${r ? '' : ' fk-dyes__swatch--natural'}`}
            data-testid="dye-swatch" data-dye={d} onClick={() => onChange(d)}>
            {r ? r.ramp.map((h, i) => <span key={i} style={{ background: `#${h}` }} />) : <span />}
          </button>
        );
      })}
      <span className="fk-dyes__name" aria-live="polite">{dyeName(value)}{value === current ? ' (as now)' : ''}</span>
    </div>
  );
}
